/**
 * Enum specifying the return type for sanitization operations.
 * Extracted to its own module to keep getTrustedHTML focused on orchestration.
 */
export enum SanitizerReturnType {
    String,
    HTMLElement,
    DocumentFragment,
    Node,
    TrustedHTML
}
